function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLowesLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.239998,
    height: 40.970001,
    id: "svg5890",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.25097,-378.28528)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 155.87597,378.28528 -23.0475,9.8725 h -14.37625 v 4.0275 h -7.20125 v 27.07 h 89.24 v -27.07 h -7.1975 v -4.0275 h -14.37125 z",
    id: "path5808",
    style: {
      fill: "#004990",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 177.1571,395.35728 -0.001,4.37625 2.83125,0.005 0.59,-4.38 -3.42,-10e-4 z",
    id: "path5812",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 192.46547,399.1493 c 0.1825,0 0.3475,-0.0137 0.3475,-0.23625 0,-0.175 -0.1625,-0.2075 -0.3125,-0.2075 h -0.295 v 0.44375 z m -0.26,0.8025 h -0.21625 v -1.43 h 0.545 c 0.33625,0 0.50375,0.125 0.50375,0.4075 0,0.25625 -0.15875,0.3675 -0.36875,0.39375 l 0.40625,0.62875 h -0.2425 l -0.3775,-0.62 h -0.25 z m 0.2625,0.32 c 0.56125,0 1.00375,-0.43875 1.00375,-1.0375 0,-0.5875 -0.4425,-1.03 -1.00375,-1.03 -0.56875,0 -1.01125,0.4425 -1.01125,1.03 0,0.59875 0.4425,1.0375 1.01125,1.0375 m -1.26125,-1.0375 c 0,-0.7125 0.5775,-1.2375 1.26125,-1.2375 0.67625,0 1.255,0.525 1.255,1.2375 0,0.7175 -0.57875,1.245 -1.255,1.245 -0.68375,0 -1.26125,-0.5275 -1.26125,-1.245",
    id: "path5824",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125.48622,410.27055 V 395.3568 h -4.07875 v 18.465 h 10.39 v -3.55125 z",
    id: "path5828",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.54685,413.82243 h 9.70875 v -3.55625 h -5.61 v -2.3175 h 5.61 v -3.42375 h -5.61 v -2.33 h 5.61 v -3.57125 h -9.70875 v 0.0175 z",
    id: "path5832",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.11985,402.1953 h -3.5875 v 8.05625 h 3.5875 z m 4.08625,9.68625 c 0,1.07125 -0.86875,1.94125 -1.94125,1.94125 h -7.87875 c -1.07125,0 -1.94,-0.87 -1.94,-1.94125 V 400.5653 c 0,-1.0725 0.86875,-1.94125 1.94,-1.94125 h 7.87875 c 1.0725,0 1.94125,0.86875 1.94125,1.94125 z",
    id: "path5834",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.12797,398.62442 v 11.64625 h -2.4625 v -11.64625 h -3.5875 v 11.64625 h -2.4625 v -11.64625 h -4.08625 v 13.25625 c 0,1.0725 0.86875,1.9425 1.94125,1.9425 h 4.83 c 0.81375,0 1.57125,-0.5625 1.57125,-1.37625 0,0.81375 0.7575,1.37625 1.57125,1.37625 h 4.83125 c 1.07125,0 1.94,-0.87 1.94,-1.9425 v -13.25625 z",
    id: "path5838",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 190.57835,408.07905 0.001,0.001 -0.025,-0.0525 c -0.0162,-0.0325 -0.0325,-0.0638 -0.0487,-0.0962 l -0.025,-0.05 c -0.64625,-1.29625 -2.09375,-2.37875 -4.42375,-3.31125 l -0.0825,-0.0312 c -0.46125,-0.18125 -1.865,-0.73 -2.02125,-1.6225 -0.0425,-0.25 0.0588,-0.6425 0.3375,-0.88125 0.29375,-0.29875 0.74375,-0.4525 1.3375,-0.4525 0.95,0 2.03,0.38875 2.59,0.62 1.17875,0.48875 2.2125,0.925 2.2225,0.93125 l 0.1025,0.0425 v -3.3175 l -0.0337,-0.0213 c -0.0225,-0.015 -2.25125,-1.42 -4.5025,-1.7425 -0.25875,-0.0225 -0.515,-0.0325 -0.76125,-0.0325 -2.0725,0 -3.6425,0.7525 -4.665,2.2375 -0.85875,1.22 -0.95375,3.15125 -0.22375,4.5925 0.93875,1.62875 2.44375,2.30875 3.9,2.9675 0.6,0.27 1.22125,0.5525 1.8025,0.8975 l 0.006,0.004 c 0.6575,0.395 0.9925,0.99875 0.85375,1.535 -0.14375,0.55625 -0.78,0.93 -1.58375,0.93 -0.11,0 -0.22125,-0.006 -0.33,-0.0212 l -0.0388,-0.005 c -1.54625,-0.215 -4.68125,-1.3825 -4.7125,-1.395 l -0.1,-0.0375 v 3.6375 l 0.0513,0.0175 c 0.0288,0.01 3.06375,1.015 5.7575,1.015 h 0.001 c 1.47,0 2.58,-0.29625 3.2975,-0.87875 0.0175,-0.0125 1.66375,-1.33625 1.73625,-3.5875 0.02,-0.6225 -0.12125,-1.26 -0.42,-1.8925",
    id: "path5842",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLowesLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lowes_logo.83500a07354c464b4e617e8e380c6a08.svg";